export default __webpack_public_path__ + "static/media/selectTeam3.64d0aecf.mp3";